import React, { useState, useEffect } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, MasterDetailForm, Widget, FormInput } from '@digital/ui';
import { getLoggedUsername } from '@app/helpers';
import { hasPermission } from '@app/helpers/permissions';
import { getAllProjetos } from '@app/api/projeto';
import { Collapse, Icon } from 'antd';

interface Referencia {
    id: string;
    nome: string;
}

const ReferenciaCrudMaster = () => {
    const { Panel } = Collapse;
    const [projetos, setProjetos] = useState(() => getAllProjetos);

    return (
        <CrudMasterDetailView
            getAllItems={projetos}
            filterPredicate={(item, value) =>
                item.nome.toString().startsWith(value)
            }
            titleExtractor={item =>
                item.nome.toString()
            }
            detailTitleExtractor={
                item =>
                    item.nome
            }
            descriptionExtractor={item => item.nome || '---'} >
            <CrudContext.Consumer>
                {({ selectedItem }) => (
                    <CompositeView>
                        {true ? (
                            <GridView icon="commons-document" id="geral" noform title="GERAL">
                                <>
                                    <Collapse
                                        bordered={false}
                                        defaultActiveKey={['fornecedorContrato']}
                                        expandIcon={() => <Icon type="arrows-right_4" />}>
                                        <Panel key="fornecedorContrato" header={<span>Collapse 1 </span>} style={{ border: 0 }}>
                                            <MasterDetailForm initialValues={[]}>
                                                <Widget>
                                                    <FormInput label="Número" name="fornecedor_Numero" span={6} disabled />
                                                </Widget>
                                            </MasterDetailForm>
                                        </Panel>
                                    </Collapse>

                                    <Collapse
                                        bordered={false}
                                        defaultActiveKey={['fornecedorContrato']}
                                        expandIcon={() => <Icon type="arrows-right_4" />}>
                                        <Panel key="fornecedorContrato" header={<span>Collapse 2 </span>} style={{ border: 0 }}>
                                            <MasterDetailForm initialValues={[]}>
                                                <Widget>
                                                    <FormInput label="Número" name="fornecedor_Numero" span={6} disabled />
                                                </Widget>
                                            </MasterDetailForm>
                                        </Panel>
                                    </Collapse>

                                    <Collapse
                                        bordered={false}
                                        defaultActiveKey={['fornecedorContrato']}
                                        expandIcon={() => <Icon type="arrows-right_4" />}>
                                        <Panel key="fornecedorContrato" header={<span>Collapse 3 </span>} style={{ border: 0 }}>
                                            <MasterDetailForm initialValues={[]}>
                                                <Widget>
                                                    <FormInput label="Número" name="fornecedor_Numero" span={6} disabled />
                                                </Widget>
                                            </MasterDetailForm>
                                        </Panel>
                                    </Collapse>
                                </>
                            </GridView>
                        ) : (
                                () => { }
                            )}

                        {true ? (
                            <GridView icon="commons-document" id="novo" noform title="Nova">

                            </GridView>
                        ) : (
                                () => { }
                            )}
                    </CompositeView>
                )}
            </CrudContext.Consumer>
        </CrudMasterDetailView >
    );
};

export default ReferenciaCrudMaster;
